import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateDesignation } from "../designationsThunks";
import {
  setSelectedDesignation,
  setIsEditDesignation,
} from "../designationsSlice";
import { getAccessType } from "../../../lib/functions";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateDesignationForm = () => {
  const { modal } = App.useApp();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = useForm();

  const { isEditDesignation, selectedDesignation } = useSelector(
    (state) => state.designations
  );

  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("designation_entry");
    access_type_set(access);
  }, []);


  useEffect(() => {
    if (isEditDesignation && selectedDesignation) {
      form.setFieldsValue(selectedDesignation);
    } else {
      form.resetFields();
    }
  }, [isEditDesignation, selectedDesignation]);

  const handleCancel = () => {
    dispatch(setSelectedDesignation(null));
    dispatch(setIsEditDesignation(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateDesignation({
          ...values,
          action: isEditDesignation ? "update" : "create",
          designation_id: selectedDesignation?.designation_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditDesignation
          ? "Designation updated successfully"
          : "Designation created successfully",
      });

      dispatch(setSelectedDesignation(null));
      dispatch(setIsEditDesignation(false));

      // ✅ Check if there's a return URL from query params
      const returnUrl = searchParams.get("returnUrl");

      if (returnUrl) {
        // navigate back to parent page (employee form)
        window.location.href = `${returnUrl}?restoreDraft=true`;
      } else {
        // default fallback behavior
        navigate("/hrpayroll/designations");
      }

    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="designation-form">
      <Title
        level={2}
        style={{
          marginBottom: "32px",
          wordBreak: "break-word",
          fontSize: screens.md ? undefined : "20px",
        }}
      >
        {isEditDesignation ? "Update Designation" : "Create New Designation"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Designation Name"
              name="designation_name"
              rules={[{ required: true }]}
            >
              <InputField placeholder="Enter Designation Name" data-testid="designation-name-input" />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="traic-button"
              data-testid="save-designation-btn"
            >
              {isEditDesignation ? "Update" : "Save"}
            </Button>
          </>}

        </Flex>
      </Form>
    </div>
  );
};

export default CreateDesignationForm;
